import request from '@/utils/request';

export interface LoginParamsType {
  loginName: string;
  password: string;
}


export async function getDepartmentList(): Promise<any> {
  return request('/sys/department/list',{
    method: 'POST'
  });
}


export async function departmentUpdate(data:{"name":string,id:string}): Promise<any> {
    return request('/sys/department/update',{
      method: 'POST',
      data
    });
}

export async function departmentAdd(data:{"name":string}): Promise<any> {
  return request('/sys/department/add',{
    method: 'POST',
    data
  });
}

export async function departmenDelete(data:{"id":string}): Promise<any> {
    return request('/sys/department/delete',{
      method: 'POST',
      data
    });
}